module.exports = require("@swa-ui/core/src/Interstitial/Interstitial.module.scss");